<flow-header [title]="'Persons of Interest (POI)'">
  <div class="flex flex-row flex-1 justify-between items-center gap-4">
    <div class="flex flex-row flex-1 items-center gap-4">
      <flow-dropdown-button [title]="'global.add' | translate">
        <a *flowHasPermission="[Permissions.UpdatePoiInsights]; disabled true;" [routerLink]="['/person-of-interest/create']" mat-menu-item>
          {{ 'poi.personOFInterest' | translate}}
        </a>
        <a *flowHasPermission="[Permissions.UpdatePoiCategoriesInsights]; disabled true;" [routerLink]="['/categories/create']" mat-menu-item>
          {{'poi.poiCategory' | translate}}
        </a>
      </flow-dropdown-button>

      <flow-button theme="danger" variation="fill" (onClick)="onDeleteSelected($event)" *ngIf="isButtonShown()">
        {{ 'poi.deletePoi' | translate }}
      </flow-button>
    </div>

    <app-icon mat-ripple class="cursor-pointer rounded-full" iconName="question" size="md" fill="#1f5792" (click)="toggleSidePanel()"></app-icon>

    <flow-button *ngIf="selectedTabIndex==0" theme="secondary" variation="outline" (onClick)="openFilters()">
      <app-icon fill="none" [stroke]="'#202020'" iconName="filter-lines" size="md"></app-icon>
      <span class="pl-2">{{'global.filter' | translate}}</span>
      <span *ngIf="filtersNumber > 0" class="filters-count">{{filtersNumber}}</span>
    </flow-button>
  </div>
</flow-header>

<div class="mt-5 px-2">
  <mat-tab-group
    (selectedTabChange)="tabChange($event)"
    [(selectedIndex)]="selectedTabIndex"
    animationDuration="0ms"
    mat-stretch-tabs="false"
    class="mat-tabs-override">
    <mat-tab [disabled]="disablePoiInsights" label="{{'poi.overview' | translate}}">
      <br />
      <ng-container *ngIf="dataSource?.data?.length===0;else poiTable">
        <div class="no-data-selected-container">
          <img src="../../../../assets/no-data.png" />
          <p>{{'global.noDataFound' | translate }}</p>
          <p class="no-data-subtitle">{{'global.pleaseSelectDifferentFilters' | translate}}</p>
        </div>
      </ng-container>
    </mat-tab>
    <mat-tab [disabled]="disablePoiCategoriesInsights" label="{{'poi.categories' | translate}}">
      <br />
      <flow-category [deletedPOI]="deletedPOI"></flow-category>
    </mat-tab>
    <mat-tab [disabled]="disablePoiReportsInsights" label="{{'poi.reports' | translate}}">
      <br />
      <flow-reports [reportType]="ActiveReportEnum.POI" [permissions]="['ExportPoiReportsInsights']"></flow-reports>
    </mat-tab>
  </mat-tab-group>

  <ng-template #poiTable>
    <div>
      <mat-paginator
        class="mb-4"
        (page)="handlePageEvent($event)"
        [pageSize]="params.pageSize"
        [pageIndex]="params.pageNumber"
        [pageSizeOptions]="pageSizeOptions"
        [length]="totalCount"
        showFirstLastButtons></mat-paginator>
      <table
        [dataSource]="dataSource"
        mat-table
        matSort
        (matSortChange)="handleSortEvent($event)"
        matSortActive="name"
        matSortDirection="asc"
        [matSortDisableClear]="true">
        <ng-container *ngIf="!isAdmin" matColumnDef="checkbox">
          <th *matHeaderCellDef mat-header-cell>
            <mat-checkbox
              color="primary"
              (change)="selectMedias($event,null)"
              [checked]="isAllSelected"
              id="select-media-checkbox-all"></mat-checkbox>
          </th>
          <td *matCellDef="let poi" mat-cell>
            <mat-checkbox
              color="primary"
              (change)="selectMedias($event, poi.media)"
              [checked]="poi.isSelected"
              [id]="'select-media-checkbox'+poi.id"></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'poi.table.id' | translate }}</th>
          <td *matCellDef="let poi" mat-cell>{{ poi.id }}</td>
        </ng-container>

        <ng-container matColumnDef="media">
          <th *matHeaderCellDef mat-header-cell>{{ 'poi.table.file' | translate }}</th>
          <td *matCellDef="let poi" mat-cell>
            <flow-media-preview [media]="poi.media" [type]="poi.media?.type"></flow-media-preview>
          </td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'poi.table.name' | translate }}</th>
          <td *matCellDef="let poi" mat-cell>{{ poi.name }}</td>
        </ng-container>

        <ng-container matColumnDef="category">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'poi.table.category' | translate }}</th>
          <td *matCellDef="let poi" mat-cell>{{ poi.category?.name }}</td>
        </ng-container>

        <ng-container matColumnDef="tags">
          <th *matHeaderCellDef mat-header-cell>{{ 'poi.table.tags' | translate }}</th>
          <td *matCellDef="let poi" mat-cell>
            <mat-chip-listbox *ngIf="poi?.tags?.length" class="chip-list-small">
              <mat-chip-option *ngFor="let tag of poi.tags">
                {{ tag?.name }}
              </mat-chip-option>
            </mat-chip-listbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="fileName">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'poi.table.fileName' | translate }}</th>
          <td *matCellDef="let poi" mat-cell>
            <p [ellipsisTooltip]="poi.fileName" class="truncate max-w-[200px]">{{ poi.fileName }}</p>
          </td>
        </ng-container>

        <ng-container matColumnDef="customer">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'poi.table.customer' | translate }}</th>
          <td *matCellDef="let poi" mat-cell>{{ poi.customer?.name }}</td>
        </ng-container>

        <ng-container matColumnDef="size">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'poi.table.size' | translate }}</th>
          <td *matCellDef="let poi" mat-cell>{{ poi.size | filesize }}</td>
        </ng-container>

        <ng-container matColumnDef="created">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ 'poi.table.created' | translate }}</th>
          <td *matCellDef="let poi" mat-cell>{{ poi.createdDate }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th *matHeaderCellDef class="actions-col" mat-header-cell></th>
          <td *matCellDef="let poi" [style.width]="'1px'" mat-cell>
            <button [matMenuTriggerFor]="menu" mat-icon-button>
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button *flowHasPermission="[Permissions.UpdatePoiInsights]; disabled true;" (click)="showCreatePoiModal($event,poi.id)" mat-menu-item>
                {{ 'global.edit' | translate }}
              </button>
              <button *flowHasPermission="[Permissions.UpdatePoiInsights]; disabled true;" (click)="onDeleteClick($event, poi)" mat-menu-item>
                {{ 'global.delete' | translate }}
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr class="bg-gray-50" *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr
          (dblclick)="showCreatePoiModal($event, poi.id)"
          *matRowDef="let poi; columns: displayedColumns; let odd = odd"
          mat-row
          [ngClass]="odd ? 'bg-gray-50' : 'bg-white'"
          class="hover:bg-gray-200 cursor-pointer"></tr>
      </table>
    </div>
  </ng-template>
</div>
